import {Map, Set} from 'immutable';
import {joinJobStatusTopics} from '../actions';
import {refreshRecord} from 'requests/actions';

let jobsStore;

function nonChattyObserve(store, select, onChange) {
  let currentState;

  function handleChange() {
    const nextState = select(store.getState());

    if (nextState !== currentState) {
      currentState = nextState;
      onChange(currentState);
    }
  }

  let unsubscribe = store.subscribe(handleChange);
  handleChange();
  return unsubscribe;
}

export function dispatch(action) {
  jobsStore.dispatch(action);
}

export function observer(store) {
  let currentJobs = Set();
  let currentStatus = Set();

  jobsStore = store;

  const jobDiscover = (jobs) => {
    const changedJobs = jobs.toSet().subtract(currentJobs);

    if (!changedJobs.isEmpty()) {
      dispatch(joinJobStatusTopics([...changedJobs]));
    }

    currentJobs = jobs.toSet();
  };

  const jobStatusFinished = (status) => {
    for (const [id, entry_status] of status.entries()) {
      if (~['finished', 'errored'].indexOf(entry_status) && currentStatus.get(id) === 'processing') {
        jobsStore.getState().requests.get('representations').forEach((typeGrouping) => {
          typeGrouping.forEach((record) => {
            if (record.jobStatusTopic === id) {
              dispatch(refreshRecord(record));
            }
          });
        });
      }
    }

    currentStatus = status;
  };

  nonChattyObserve(
    store,
    (state) => state['requests'].get('jobs'),
    jobDiscover
  );

  nonChattyObserve(
    store,
    (state) => state['jobs'].get('status'),
    jobStatusFinished
  );
}



// WEBPACK FOOTER //
// ./app/javascript/store/jobs.js